<template>
  <v-container>
    <v-layout>
      <v-container>
        <v-card>
          <v-toolbar
            card
            color="#0C116F">
            <v-toolbar-title class="white--text">Export Entities</v-toolbar-title>
          </v-toolbar>

          <v-card-title>Can be directly downloaded from S3. Will be refreshed every 60 minutes.</v-card-title>

              <v-btn @click="downloadcsv"
                     color="green darken-1"
                     class="white--text"
                     large>
                Download entity csv
              </v-btn>
              <v-btn @click="cancel">Cancel</v-btn>


          <v-card-text>
          <v-divider class="my-2"></v-divider>

          <div>
            <p>
              Format of the exported CSV files:
            </p>
            <ul>
              <li>Tab separated (<code>\t</code>) values</li>
              <li>Encoding <code>UTF-8</code></li>
              <li>
                Field Names:
                <ul>
                  <li><code>Uuid</code></li>
                  <li><code>Entity_Name</code></li>
                  <li><code>Tags</code> (comma separated list of tags e.g. <code>TOP5000,DAX</code>)</li>
                  <li><code>Entity_Search_Query</code> (Search Query used in the Entity)</li>
                  <li><code>Fulltext_Search_Query</code> (The search query used in the Fulltext search. Is normally similar to the <code>Entity_Search_Query</code> for singles searches.)</li>
                  <li><code>Country_Code</code> (currently DE, IT or AT)</li>
                  <li><code>Pattern_Definitions</code></li>
                  <li><code>Regex_for_Processing</code></li>
                  <li><code>Regex_from_Fulltext_search</code></li>
                  <li><code>Revision</code></li>
                  <li><code>UpdatedAt</code></li>
                  <li><code>CreatedAt</code></li>
                  <li><code>Update_Note</code></li>
                  <li><code>Industry_1</code></li>
                  <li><code>Industry_2</code></li>
                  <li><code>Industry_Final</code></li>
                  <li><code>Additional_AND_NOTs</code></li>
                  <li><code>Regex_Additional_AND_NOTs</code></li>
                  <li><code>Account_Search_Ids</code></li>
                  <li><code>Industries_Austria</code></li>
                  <li><code>Industries_Switzerland</code></li>
                  <li><code>Kununu_Links</code></li>
                  <li><code>Twitter_Authors</code></li>
                </ul>
              </li>
            </ul>
          </div>
          </v-card-text>
         <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :top="true"
              multi-line
              :timeout="60000"              
              :vertical="true"
              :auto-height="true"
            >
            <a v-bind:href="text">{{text}}</a>
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>          
          
        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'
  export default {
    data () {
      return {url: '',
              text: '',
            snackbar: false,  
        url_all: 'https://s3.amazonaws.com/beas-d2r-entity-mngmnt-api-exportbucket-1wbv7xeei6kor/exported-entities.csv'
      }
    },
    mounted() {
      this.$emit('TriggerLoading', false)
    },
    methods: {
      'cancel': function () {
        this.$router.go(-1)
      },
      'downloadcsv': function () {
        this.$emit('TriggerLoading', true)
        axios
          .get(`${Config.API_URL}/download_csv`)
          .then(response => {
            console.info(response.data)
            this.text = response.data.url
            this.snackbar = true
            this.$emit('TriggerLoading', false)
          })
          .catch(error => {
            this.$emit('TriggerLoading', false)
          })
      }
    },      
 }       
</script>



